import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";
import { PageTransition } from "@/components/motion";

export default function Layout() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      <Sidebar />
      <div className="md:mr-72">
        <Header />
        <main className="p-4 md:p-8 thin-scroll">
          <AnimatePresence mode="wait">
            <PageTransition key={location.pathname}>
              <Outlet />
            </PageTransition>
          </AnimatePresence>
        </main>
      </div>
    </div>
  );
}
